import { PackLite } from '@shared/models/generic/pack-lite.model';

export const BINARY_TARGET_DOMAIN = 'PRO_COO';

export function hasTargetDomainForBinaries(pack: PackLite): boolean {
  return pack.targetDomains?.includes(BINARY_TARGET_DOMAIN) ?? false;
}
